import SaveLoadPrices from "@/store/api/data/SaveLoadPrices";

export default {
    state: {
        savedPrices: []
    },
    mutations: {
        setSavedPrices(state, savedPrices) {
            state.savedPrices = savedPrices;
        }
    },
    actions: {
        loadSavedPrices({ commit }) {
            return SaveLoadPrices.getAll().then(response => {
                commit("setSavedPrices", response.data);
                return response;
            });
        },
        async addToSavedPrices({ dispatch }, { pharmacyId, pharmacyGroupId, articles }) {
            await SaveLoadPrices.addTo({
                pharmacyId: pharmacyId,
                pharmacyGroupId: pharmacyGroupId,
                prices: articles.map(article => ({
                    pzn: article.pzn,
                    priceNew: article.priceNew
                }))
            });
            dispatch("loadSavedPrices");
        },
        async loadPrices({ dispatch }, save_id) {
            await SaveLoadPrices.loadPrices(save_id).then(response => {
                console.log(response);
                dispatch("loadPricesToArticle", response.data);
                return response;
            });
        },

        async deleteSavedPrices({ dispatch }, save_id) {
            await SaveLoadPrices.delete(save_id);
            dispatch("loadSavedPrices");
        }
    }
};
